import React, { Component } from 'react'
import * as PIXI from 'pixi.js'

const TEXTS = {
  title: 'La Tapera Invisible',
  subtitle: 'The never-ending, redundant and cyclic, recursive buggy code.'
}

export default class BackgroundCanvas extends Component {

  constructor() {
    super()
    this._updateDimensions = this._updateDimensions.bind(this)
    this._run = this._run.bind(this)
    this._drawTiles = this._drawTiles.bind(this)
  }

  _run() {
    if (process.env.NODE_ENV === 'production') {
      PIXI.utils.skipHello()
    }

    this._renderer = PIXI.autoDetectRenderer(256, 256, { antialias: true, resolution: 1 });

    document
      .querySelector('#canvas-container')
      .appendChild(this._renderer.view)

    this._renderer.backgroundColor = 0xfff8dc
    this._renderer.view.style.position = 'absolute'
    this._renderer.view.style.top = 0
    this._renderer.view.style.left = 0
    this._renderer.view.style.display = 'block'
    this._renderer.view.style.zIndex = -10
    this._renderer.autoResize = true
    this._renderer.resize(window.innerWidth, window.innerHeight)

    const stage = new PIXI.Container()
    this._drawTiles(stage)
    this._drawInfo(stage)

    const animate = () => {
      requestAnimationFrame(animate);
      this._renderer.render(stage)
    }

    animate()

    window.addEventListener('resize', () => {
      this._updateDimensions(stage)
    })
  }

  _updateDimensions() {
    window.location.reload()
  }

  _drawInfo(stage) {
    const { innerWidth } = window
    const x = 20
    const titleY = 70 // this._renderer.height
    const titleFontSize = parseInt(innerWidth * .07, 10)
    const title = this.__drawText(TEXTS.title,
      x, titleY, {
        fontFamily: 'Courier',
        fontSize: titleFontSize,
        fontWeight: 'bold',
        fill: 'steelblue',
        wordWrap: true,
        wordWrapWidth: innerWidth * .9
      })

    const subTitleFontSize = parseInt(innerWidth * .02, 10)
    const subTitleY = titleY + titleFontSize * 1.2
    const subTitle = this.__drawText(TEXTS.subtitle,
      x, subTitleY, {
        fontFamily: 'Courier',
        fontSize: subTitleFontSize,
        fill: 'seagreen',
        wordWrap: true,
        wordWrapWidth: innerWidth * .9
      })

    stage.addChild(title)
    stage.addChild(subTitle)
  }

  static __getRandomColor = () => {
    const COLORS = [
      'aaaaaa', 'bbbbbb', 'cccccc'
    ]
    const IDX = parseInt(Math.random() * COLORS.length, 10)
    return COLORS[ IDX ]
  }

  _drawTiles(stage) {
    const H = 3
    const W = 3

    const scrHeight = this._renderer.height / 3
    const scrWidth = this._renderer.width

    for (let x = 0; x < scrWidth; x += W) {
      for (let y = 0; y < scrHeight; y += H) {
        const pow = parseInt(Math.random() * 2, 10)
        if (x % 2 === pow && y % 3 === pow) {
          const boxColor = BackgroundCanvas.__getRandomColor()
          const sqr = this.__drawSquare(x, y, W, H, boxColor)
          stage.addChild(sqr)

          sqr.interactive = true

          sqr.mouseover = function () {
            this.alpha = 1
            this.fill = BackgroundCanvas.__getRandomColor()
          }

          sqr.mouseout = function () {
            this.alpha = .8
            this.fill = boxColor
          }

          const eternalSunshine = () => {
            const TIMEOUT_INTERVAL = 60000
            this._timeout = null

            setInterval(() => {
              if (this._timeout) {
                clearTimeout(this._timeout)
              }
              sqr.alpha = .2
              this._timeout = setTimeout(() => {
                sqr.alpha = .8
              }, Math.random() * TIMEOUT_INTERVAL)
            }, Math.random() * TIMEOUT_INTERVAL)
          }

          eternalSunshine()
        }
      }
    }
  }

  __drawText(txt, x, y, style) {
    const textStyle = new PIXI.TextStyle(style)
    const richText = new PIXI.Text(txt, textStyle)

    richText.x = x
    richText.y = y

    return richText
  }

  __drawSquare(x, y, w, h, color) {
    let graphics = new PIXI.Graphics()
    graphics.beginFill(`0x${color}`)
    graphics.alpha = .8
    graphics.drawRect(x, y, w, h)
    return graphics
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions)
  }

  componentDidMount() {
    this._run()
  }

  render() {
    return <div id="canvas-container" />
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/BackgroundCanvas.js
 **/